import { UpdateDocumentVirusScanStatusResponse } from "@performyard/service-contracts";

import { DocumentsData, EditDocumentParams } from "../../../pages/Documents/schema";

import request from "../base-request";
import internalRequest from "./internal-api/internal-base-request";

export const getDocuments = async (fromUserId: string) => {
	const [data] = await request<DocumentsData>(`/api/documents/?userId=${fromUserId}`, {
		method: "GET",
	});
	return data;
};

export const deleteDocument = async (id: string) => {
	const [data] = await request(`/api/delete_document/?fid=${id}`, {
		method: "POST",
	});
	return data;
};

export const editDocument = async (params: EditDocumentParams) => {
	const [data] = await request(`/api/edit_document/`, {
		method: "POST",
		body: JSON.stringify(params),
	});
	return data;
};

export const uploadFile = (file, uploadUrl, docVisibilities, userId, tags, allowAiRetrieval = true) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = async () => {
			const dataUrl = reader.result as string;
			const uploadData = {
				file: dataUrl,
				filename: file.name,
				tags,
				// For company documents: true = Everyone, false = Administrators Only
				visible_to_everyone: docVisibilities.some((v) => v.value === "vis_to_everyone"),
				// For user documents: checkboxes
				vis_to_emp: docVisibilities.some((v) => v.value === "vis_to_emp"),
				vis_to_m: docVisibilities.some((v) => v.value === "vis_to_m"),
				uid: userId,
				allow_ai_retrieval: allowAiRetrieval,
			};
			try {
				const res = await fetch(uploadUrl, {
					method: "POST",
					body: JSON.stringify(uploadData),
					headers: { "Content-Type": "application/json" },
				});
				const data = await res.json();
				if (data.errors?.length === 0) {
					resolve(data.response);
				} else {
					reject(data.errors[0]);
				}
			} catch (err) {
				reject("Server error");
			}
		};
		reader.readAsDataURL(file);
	});
};

/**
 * Hits the internal API endpoint that checks a document's tags for virus scanning results.
 * Updates the "pending" and "clean" properties if necessary.
 * Returns a status of "clean", "unsafe", or "no-tag" for immediate use.
 */
export const updateDocumentVirusScanStatus = async (documentId: string) => {
	const [data] = await internalRequest<UpdateDocumentVirusScanStatusResponse>(
		`/v1/document/virus-scan/${documentId}`,
		{
			method: "PATCH",
			body: JSON.stringify({}),
		}
	);
	return data;
};
